import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { enpointCervinoWeb } from 'src/app/configuration/enpointsCervino';
import { ColumnResponseModel } from 'src/app/models/responses/column-response.model';
import { PagedResponseModel } from 'src/app/models/responses/paged-response.model';
import { InternalOrderDetailModel } from 'src/app/models/shopping/internal-order-detail.model';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class InternalOrderDetailService {

  constructor(private _httpClient: HttpClient) { }

  createInternalOrderDetail(listArticles: number[], internalOrderId: number): Observable<boolean> {
    return this._httpClient.post<boolean>(`${environment.apiCervinoBackend}${enpointCervinoWeb.internalOrderDetail.CreateInternalOrderDetail}/${internalOrderId}`,
      listArticles);
  }

  createByQuotation(breakdownIds: number[], internalOrderId: number): Observable<boolean> {
    return this._httpClient.post<boolean>(`${environment.apiCervinoBackend}${enpointCervinoWeb.internalOrderDetail.CreateByQuotation}/${internalOrderId}`,
      breakdownIds);
  }

  deleteDetails(orderDetailIds: number[]): Observable<boolean> {
    return this._httpClient.put<boolean>(`${environment.apiCervinoBackend}${enpointCervinoWeb.internalOrderDetail.DeleteDetails}`,
      orderDetailIds);
  }

  exportDetailConsultation(filters: ColumnResponseModel[], columnSort: string | null, ascendant: boolean): Observable<Blob> {
    const params = new HttpParams()
      .set('columnSort', columnSort ?? '')
      .set('ascendant', ascendant.toString());

    return this._httpClient.post(`${environment.apiCervinoBackend}${enpointCervinoWeb.internalOrderDetail.ExportDetailConsultation}`, filters, {
      params,
      responseType: 'blob',
    });
  }

  getAllInternalOrderDetails(page: number, limit: number, columnSort: string | null, ascendant: boolean, filters: ColumnResponseModel[]): Observable<PagedResponseModel<any>> {
    const params = new HttpParams()
      .set('page', page)
      .set('limit', limit)
      .set('columnSort', columnSort || '')
      .set('ascendant', ascendant);
    return this._httpClient.post<PagedResponseModel<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.internalOrderDetail.GetAllInternalOrderDetails}`,
      filters, { params: params }
    );
  }

  getColumnsForDetailCapture(): Observable<ColumnResponseModel[]> {
    return this._httpClient.get<ColumnResponseModel[]>(`${environment.apiCervinoBackend}${enpointCervinoWeb.internalOrderDetail.GetColumnsForDetailCapture}`);
  }

  getColumnsForDetailConsultation(): Observable<ColumnResponseModel[]> {
    return this._httpClient.get<ColumnResponseModel[]>(`${environment.apiCervinoBackend}${enpointCervinoWeb.internalOrderDetail.GetColumnsForDetailConsultation}`);
  }

  getInternalOrderDetailById(internalOrderDetailId: number): Observable<InternalOrderDetailModel> {
    return this._httpClient.get<InternalOrderDetailModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.internalOrderDetail.GetInternalOrderDetailById}/${internalOrderDetailId}`);
  }

  getInternalOrderDetailsByInternalOrder(page: number, limit: number, columnSort: string | null, ascendant: boolean, internalOrderId: number): Observable<PagedResponseModel<any>> {
    const params = new HttpParams()
      .set('page', page)
      .set('limit', limit)
      .set('columnSort', columnSort || '')
      .set('ascendant', ascendant)
      .set('internalOrderId', internalOrderId);
    return this._httpClient.get<PagedResponseModel<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.internalOrderDetail.GetInternalOrderDetailsByInternalOrder}`,
      { params }
    );
  }

  updateInternalOrderDetail(internalOrderDetailContract: InternalOrderDetailModel): Observable<InternalOrderDetailModel> {
    return this._httpClient.put<InternalOrderDetailModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.internalOrderDetail.UpdateInternalOrderDetail}`,
      internalOrderDetailContract);
  }
}
